import Vue from "vue"
import * as VueGoogleMaps from "vue2-google-maps"

Vue.use(VueGoogleMaps, {
	load: {
		key: "AIzaSyCZBWYU0MLDbl-qwld3DEqmLgCo3VWynTQ",
		libraries: "places,geometry",
		region: "ID",
		language: "id",
		v: '3.26'
	},
  installComponents: true
})

export default VueGoogleMaps